import type Pageable from 'models/Pageable';
import type { EarlyRepaymentRequestVO, EarlyRepaymentRequestVOModel } from 'models/vo/EarlyRepaymentRequestVO';
import { formattingToEarlyRepaymentRequestVOModel } from 'models/vo/EarlyRepaymentRequestVO';
import http from 'utils/http';
import API_FI from 'utils/http/api/financier';

import type { FinancierEarlyRepaymentListRequest } from './request';

export async function requestFinancierEarlyRepaymentList(
  pageNumber: number,
  rowCount: number,
  searchValue: FinancierEarlyRepaymentListRequest,
): Promise<Pageable<EarlyRepaymentRequestVOModel[]>> {
  const response = await http.get<Pageable<EarlyRepaymentRequestVO[]>>({
    url: API_FI.EARLY_REPAYMENT_REQUESTS.EARLY_REPAYMENT_LIST,
    data: {
      pageNumber,
      rowCount,
      ...searchValue,
    },
  });

  return {
    ...response,
    content: response.content.map(item => formattingToEarlyRepaymentRequestVOModel(item)),
  };
}

export async function requestFinancierEarlyRepaymentDetail(
  earlyRepaymentId: number,
): Promise<EarlyRepaymentRequestVOModel> {
  const response = await http.get<EarlyRepaymentRequestVO>({
    url: API_FI.EARLY_REPAYMENT_REQUESTS.EARLY_REPAYMENT_DETAIL(earlyRepaymentId),
  });

  return formattingToEarlyRepaymentRequestVOModel(response);
}

export async function requestFinancierEarlyRepaymentComplete(
  earlyRepaymentId: number,
): Promise<EarlyRepaymentRequestVOModel> {
  const response = await http.put<EarlyRepaymentRequestVO>({
    url: API_FI.EARLY_REPAYMENT_REQUESTS.COMPLETE_EARLY_REPAYMENT(earlyRepaymentId),
  });

  return formattingToEarlyRepaymentRequestVOModel(response);
}

export async function requestFinancierEarlyRepaymentExpire(
  earlyRepaymentId: number,
): Promise<EarlyRepaymentRequestVOModel> {
  const response = await http.put<EarlyRepaymentRequestVO>({
    url: API_FI.EARLY_REPAYMENT_REQUESTS.EXPIRE_EARLY_REPAYMENT(earlyRepaymentId),
  });

  return formattingToEarlyRepaymentRequestVOModel(response);
}
